/**
 * Pages that read like a magazine, not a shop: a shared trip at
 * /trip/shared/<token>, or the short link's /trip/shared/<token>/<slug>
 * (the same page). On these the site drops its store chrome (trust bar,
 * mega-nav, breadcrumbs, chat bubble) for one slim 56px bar, so the hero
 * starts near the top of the screen.
 */
export function isSharePagePath(pathname: string | null | undefined): boolean {
  return /(^|\/)trip\/shared\/[^/]+(\/[^/]+)?\/?$/.test(pathname || '');
}
